<template>
  <div>
    <a :class="classA" @click="$emit('click', $event)">
      <div class="tabTitle">
        <slot name="icon"></slot>
        <span>{{ label }}</span>
        <font-awesome-icon v-if="warning" class="icon error" icon="exclamation-triangle"/>
      </div>
      <slot></slot>
    </a>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  props: {
    classA: Array,
    value: String,
    label: String,
    warning: Boolean,
    FontAwesomeIcon
  },
  data() {
    return {
      currentTab: "Store"
    };
  },
  watch: {
    warning: function(o, n) {
      console.log(o, n)
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
